var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1703,
    height: 821,
    viewBox: "0 0 1703 821",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Character-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 304.182098 818.590698 L 199.155853 779.916321 L 92.987244 818.621765 C 89.322083 819.957886 85.443298 817.243652 85.443298 813.342468 L 85.443298 813.342468 C 85.443298 811.154663 86.71283 809.165894 88.697479 808.244995 L 199.155853 756.993286 L 308.503387 808.240967 C 310.474823 809.164917 311.734192 811.145752 311.734192 813.323364 L 311.734192 813.323364 C 311.734192 817.228394 307.846252 819.940125 304.182098 818.590698 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 304.182098 818.590698 L 199.155853 779.916321 L 92.987244 818.621765 C 89.322083 819.957886 85.443298 817.243652 85.443298 813.342468 L 85.443298 813.342468 C 85.443298 811.154663 86.71283 809.165894 88.697479 808.244995 L 199.155853 756.993286 L 308.503387 808.240967 C 310.474823 809.164917 311.734192 811.145752 311.734192 813.323364 L 311.734192 813.323364 C 311.734192 817.228394 307.846252 819.940125 304.182098 818.590698 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 174.407135 788.939087 L 199.155853 779.916321 L 222.771393 788.612549 L 222.771393 768.061279 L 199.155853 756.993286 L 174.407135 768.477051 L 174.407135 788.939087 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 198.589264 819.487427 L 198.589264 819.487427 C 193.780701 819.487427 189.761536 815.832458 189.305817 811.046265 L 186.340515 779.913269 L 186.340515 521.509094 L 210.836975 521.509094 L 210.836975 779.913269 L 207.871674 811.046265 C 207.415955 815.832458 203.39679 819.487427 198.589264 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 198.589264 819.487427 L 198.589264 819.487427 C 193.780701 819.487427 189.761536 815.832458 189.305817 811.046265 L 186.340515 779.913269 L 186.340515 521.509094 L 210.836975 521.509094 L 210.836975 779.913269 L 207.871674 811.046265 C 207.415955 815.832458 203.39679 819.487427 198.589264 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 186.340515 551.600342 L 210.836975 551.600342 L 210.836975 521.509094 L 186.340515 521.509094 L 186.340515 551.600342 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#007cff",
    stroke: "none",
    d: "M 143.650482 255.286194 C 147.152893 255.218323 150.672577 256.786255 153.016327 260.68335 C 197.881256 335.292908 213.821594 424.978333 198.342072 510.547424 C 197.371613 515.909119 193.700348 518.408386 189.626251 518.686646 C 182.835052 519.149597 61.934601 518.72168 57.550232 518.712524 C 50.956406 518.699219 43.712555 513.095825 45.260803 504.536621 C 59.645782 425.019165 43.806137 341.259583 2.215759 272.096191 C -2.952896 263.500793 4.669373 255.434998 12.375061 255.286194 C 15.877472 255.218323 135.945831 255.434998 143.650482 255.286194 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 143.650482 255.286194 C 147.152893 255.218323 150.672577 256.786255 153.016327 260.68335 C 197.881256 335.292908 213.821594 424.978333 198.342072 510.547424 C 197.371613 515.909119 193.700348 518.408386 189.626251 518.686646 C 182.835052 519.149597 61.934601 518.72168 57.550232 518.712524 C 50.956406 518.699219 43.712555 513.095825 45.260803 504.536621 C 59.645782 425.019165 43.806137 341.259583 2.215759 272.096191 C -2.952896 263.500793 4.669373 255.434998 12.375061 255.286194 C 15.877472 255.218323 135.945831 255.434998 143.650482 255.286194 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "#007cff",
    stroke: "none",
    d: "M 45.260803 504.536621 C 59.645782 425.019531 43.806137 341.259583 2.215759 272.096191 C -5.30275 259.59375 14.24173 248.212891 21.740906 260.68335 C 66.605804 335.292908 82.545135 424.978333 67.065613 510.547424 C 64.478745 524.845459 42.68309 518.787964 45.260803 504.536621 L 45.260803 504.536621 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "#ffffff",
    stroke: "none",
    d: "M 45.260803 504.536621 C 59.645782 425.019531 43.806137 341.259583 2.215759 272.096191 C -5.30275 259.59375 14.24173 248.212891 21.740906 260.68335 C 66.605804 335.292908 82.545135 424.978333 67.065613 510.547424 C 64.478745 524.845459 42.68309 518.787964 45.260803 504.536621 L 45.260803 504.536621 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "#007cff",
    stroke: "none",
    d: "M 422.272949 497.989197 C 394.558899 490.921753 366.080933 487.035461 337.525635 486.318787 C 308.09549 485.580872 197.938202 486.207886 171.777527 486.197876 C 139.934479 486.184998 108.0914 490.110474 77.196442 497.989197 C 57.775055 502.942078 63.761581 530.969177 81.30307 531.293457 C 82.852356 531.322144 415.854065 531.22168 417.07782 531.277161 C 435.42804 532.110779 442.120544 503.050781 422.272949 497.989197 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "#000000",
    stroke: "none",
    opacity: 0.3,
    d: "M 422.272949 497.989197 C 394.558899 490.921753 366.080933 487.035461 337.525635 486.318787 C 308.09549 485.580872 197.938202 486.207886 171.777527 486.197876 C 139.934479 486.184998 108.0914 490.110474 77.196442 497.989197 C 57.775055 502.942078 63.761581 530.969177 81.30307 531.293457 C 82.852356 531.322144 415.854065 531.22168 417.07782 531.277161 C 435.42804 532.110779 442.120544 503.050781 422.272949 497.989197 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "#007cff",
    stroke: "none",
    d: "M 86.213348 530.695801 C 142.152069 516.430481 201.402985 516.430481 257.341705 530.695801 C 278.502594 536.092041 287.528656 503.388306 266.358612 497.989197 C 204.571716 482.232483 138.983337 482.232483 77.196442 497.989197 C 56.059967 503.379639 65.017883 536.101196 86.213348 530.695801 L 86.213348 530.695801 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fill: "#ffffff",
    stroke: "none",
    d: "M 86.213348 530.695801 C 142.152069 516.430481 201.402985 516.430481 257.341705 530.695801 C 278.502594 536.092041 287.528656 503.388306 266.358612 497.989197 C 204.571716 482.232483 138.983337 482.232483 77.196442 497.989197 C 56.059967 503.379639 65.017883 536.101196 86.213348 530.695801 L 86.213348 530.695801 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#fdb473",
    stroke: "none",
    d: "M 392.730896 320.905396 L 431.045715 319.282104 L 442.502014 311.950012 C 445.211975 310.215454 448.517029 309.6745 451.640015 310.455017 L 459.83905 312.505005 C 464.134888 313.578735 468.668823 312.134094 471.549683 308.772949 L 471.550659 308.772949 C 476.396851 303.120361 474.794678 294.437866 468.250732 290.887146 L 455.807678 284.136292 C 451.813965 281.969116 446.926025 282.312439 443.274109 285.01709 L 423.133545 299.932922 L 392.730896 297.787537 L 392.730896 320.905396 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fill: "#007cff",
    stroke: "none",
    d: "M 351.27478 172.496582 L 338.0495 289.270874 L 412.590698 294.569214 L 409.300903 321.359558 C 409.300903 321.359558 333.927612 334.550049 306.290863 327.012451 C 278.653137 319.474976 315.472595 193.224121 315.472595 193.224121 L 351.27478 172.496582 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.2,
    d: "M 351.27478 172.496582 L 338.0495 289.270874 L 412.590698 294.569214 L 409.300903 321.359558 C 409.300903 321.359558 333.927612 334.550049 306.290863 327.012451 C 278.653137 319.474976 315.472595 193.224121 315.472595 193.224121 L 351.27478 172.496582 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 327.376465 316.421692 C 307.920502 306.301331 334.023193 209.1604 343.23645 177.150391 L 315.472595 193.224121 C 315.472595 193.224121 278.653137 319.474976 306.289856 327.012085 C 323.280029 331.645752 358.290771 328.445862 382.759766 325.292908 C 366.08905 325.302063 341.714661 323.87915 327.376465 316.421692 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    fill: "#007cff",
    stroke: "none",
    d: "M 285.323273 400.501709 C 285.323273 400.501709 208.693634 416.83252 118.244598 409.92334 C 118.244598 409.92334 131.093536 260.560059 176.559631 178.805847 C 183.822815 165.746643 195.881317 156.02832 210.148285 151.583252 C 242.815338 141.405029 295.372711 132.297485 351.27478 172.496582 C 351.27478 172.496582 323.010437 225.257935 285.323273 400.501709 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.4,
    d: "M 285.323273 400.501709 C 285.323273 400.501709 208.693634 416.83252 118.244598 409.92334 C 118.244598 409.92334 131.093536 260.560059 176.559631 178.805847 C 183.822815 165.746643 195.881317 156.02832 210.148285 151.583252 C 242.815338 141.405029 295.372711 132.297485 351.27478 172.496582 C 351.27478 172.496582 323.010437 225.257935 285.323273 400.501709 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "#007cff",
    stroke: "none",
    d: "M 312.490021 209.712036 C 312.490021 212.188782 310.481964 214.196228 308.004944 214.196228 C 305.528961 214.196228 303.521912 212.188782 303.521912 209.712036 C 303.521912 207.235779 305.528961 205.228333 308.004944 205.228333 C 310.481964 205.228333 312.490021 207.235779 312.490021 209.712036 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fill: "#007cff",
    stroke: "none",
    d: "M 296.646301 255.56543 C 296.646301 258.041687 294.638245 260.049133 292.162262 260.049133 C 289.686249 260.049133 287.67923 258.041687 287.67923 255.56543 C 287.67923 253.088684 289.686249 251.081299 292.162262 251.081299 C 294.638245 251.081299 296.646301 253.088684 296.646301 255.56543 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fill: "#007cff",
    stroke: "none",
    d: "M 282.26947 316.421692 C 282.26947 318.897949 280.262421 320.905396 277.785431 320.905396 C 275.309418 320.905396 273.302399 318.897949 273.302399 316.421692 C 273.302399 313.945435 275.309418 311.937927 277.785431 311.937927 C 280.262421 311.937927 282.26947 313.945435 282.26947 316.421692 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fill: "#007cff",
    stroke: "none",
    d: "M 270.443909 367.054565 C 270.443909 369.530823 268.436859 371.53833 265.960876 371.53833 C 263.483856 371.53833 261.4758 369.530823 261.4758 367.054565 C 261.4758 364.578308 263.483856 362.570862 265.960876 362.570862 C 268.436859 362.570862 270.443909 364.578308 270.443909 367.054565 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 318.043182 267.452576 L 318.039124 267.446716 L 261.4758 280.210022 L 216.8591 267.969604 L 199.27182 217.720886 L 195.502899 189.455872 L 182.940857 189.455872 C 182.940857 189.455872 171.006439 279.450012 211.833893 316.421692 C 237.292664 339.47583 278.865753 324.463745 306.561462 309.894653 C 310.593842 294.190796 314.432953 280.073364 318.043182 267.452576 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fill: "#fdb473",
    stroke: "none",
    d: "M 354.67749 672.179626 L 335.055725 757.633667 L 359.410767 767.064575 L 394.50293 681.112854 L 354.67749 672.179626 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 357.993774 761.479126 L 335.858337 749.643433 C 334.897034 749.125122 333.703796 749.342529 332.986633 750.168335 L 317.187683 768.455933 C 315.773712 770.068298 315.935455 772.520386 317.547791 773.93335 C 317.754303 774.114929 317.980133 774.27417 318.220184 774.407349 C 327.510742 779.203247 335.967163 783.106201 347.418396 789.291321 C 360.938721 796.57666 356.636719 796.346741 372.41333 805.13324 C 381.924622 810.417114 389.540771 800.472168 385.767822 797.749512 C 368.437866 785.40033 366.129761 776.837097 362.540894 766.321777 C 361.670105 764.205078 360.051636 762.481384 357.993774 761.479126 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 157.18808 407.092834 L 276.843445 400.501709 C 276.843445 400.501709 475.64209 431.593384 472.815125 487.181274 C 469.988159 542.769043 388.961975 718.012939 388.961975 718.012939 L 341.521362 704.82251 C 341.521362 704.82251 377.65625 528.636597 401.209717 499.429626 C 401.209717 499.429626 252.74881 482.012878 215.602814 472.106628 C 195.158051 466.654541 145.882355 475.867126 157.18808 407.092834 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 381.125061 497.00708 C 381.661133 485.790466 380.548279 468.319153 372.003357 449.023376 C 360.943787 424.052856 269.94342 409.079529 226.404999 403.279968 L 157.18808 407.092834 C 145.882355 475.867126 195.158051 466.654541 215.602814 472.106628 C 244.281189 479.754578 339.288513 491.876648 381.125061 497.00708 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fill: "#fdb473",
    stroke: "none",
    d: "M 273.388855 695.715027 L 270.248596 783.336548 L 296.628998 784.592896 L 314.184753 696.971313 L 273.388855 695.715027 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 294.736908 776.62677 L 269.182526 777.167236 C 268.070648 777.186768 267.119537 777.975403 266.896759 779.06543 L 261.998688 803.182373 C 261.548035 805.319153 262.914215 807.414917 265.050446 807.865112 C 265.325104 807.922546 265.604828 807.951294 265.884583 807.950012 C 276.524017 807.570801 285.977356 806.815063 299.228088 806.590698 C 314.865295 806.31073 310.93158 808.25293 329.320435 808.179688 C 340.399353 808.123169 342.196838 795.4953 337.48999 794.961731 C 315.944611 792.648254 309.622375 786.198853 301.190369 778.655945 C 299.360321 777.21167 297.063385 776.489746 294.736908 776.62677 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 189.221375 407.097046 C 189.221375 407.097046 349.390869 412.750061 358.812622 461.742981 C 368.234436 510.735413 314.530609 730.261169 314.530609 730.261169 L 266.479675 730.261169 C 266.479675 730.261169 272.132538 533.347534 288.1492 491.892029 C 288.1492 491.892029 156.246124 512.619995 121.385895 482.682861 C 96.469299 461.285828 126.095764 407.087158 126.095764 407.087158 L 189.221375 407.097046 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 337.752441 694.45874 L 397.440796 711.10376 L 386.526672 734.051697 L 332.11792 720.525269 L 337.752441 694.45874 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fill: "#000000",
    stroke: "none",
    opacity: 0.3,
    d: "M 337.752441 694.45874 L 397.440796 711.10376 L 386.526672 734.051697 L 332.11792 720.525269 L 337.752441 694.45874 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    fill: "#fdb473",
    stroke: "none",
    d: "M 334.943848 251.010803 L 382.68042 235.307861 L 413.228516 248.945435 C 416.125671 250.238342 418.200867 252.872925 418.781738 255.992065 L 422.014526 273.37793 C 423.117249 279.311707 418.564026 284.790344 412.528687 284.790344 L 412.527649 284.790344 C 410.286621 284.790344 408.115845 284.010376 406.387512 282.584167 L 379.540161 260.432495 L 337.752441 277.252869 L 334.943848 251.010803 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 261.768768 718.012939 L 322.067444 720.8396 L 316.414581 744.865112 L 261.768768 742.038452 L 261.768768 718.012939 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "#000000",
    stroke: "none",
    opacity: 0.3,
    d: "M 261.768768 718.012939 L 322.067444 720.8396 L 316.414581 744.865112 L 261.768768 742.038452 L 261.768768 718.012939 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fill: "#007cff",
    stroke: "none",
    d: "M 186.081116 172.496582 C 195.382874 158.567505 210.148285 144.045776 247.636078 266.713806 L 359.921448 239.07666 L 363.209229 269.71582 C 363.209229 269.71582 271.504913 318.847107 234.759705 311.937927 C 198.015533 305.02832 160.530792 210.756592 186.081116 172.496582 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.2,
    d: "M 186.081116 172.496582 C 195.382874 158.567505 210.148285 144.045776 247.636078 266.713806 L 359.921448 239.07666 L 363.209229 269.71582 C 363.209229 269.71582 271.504913 318.847107 234.759705 311.937927 C 198.015533 305.02832 160.530792 210.756592 186.081116 172.496582 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fill: "#fdb473",
    stroke: "none",
    d: "M 303.521912 129.784912 L 282.26947 149.737915 C 282.26947 149.737915 290.543793 175.621216 311.802338 175.621216 C 333.06189 175.621216 320.183502 142.878296 320.183502 142.878296 L 303.521912 129.784912 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    fill: "#fdb473",
    stroke: "none",
    d: "M 314.775787 190.633301 L 325.139526 185.21582 L 329.491333 178.62085 L 327.667419 158.223755 C 308.476959 148.685425 289.990417 144.369629 272.923981 143.219604 L 272.142731 152.703247 L 283.684479 186.157898 L 297.110168 190.633301 L 314.775787 190.633301 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 320.183502 142.878296 L 303.521912 129.784546 L 300.715302 132.420044 C 299.079559 142.150757 297.206818 162.407471 308.005951 170.376648 C 312.299774 173.54541 316.410492 173.900391 320.08075 172.884949 C 328.872864 165.047913 320.183502 142.878296 320.183502 142.878296 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    fill: "#007cff",
    stroke: "none",
    d: "M 308.877747 193.224121 L 324.894409 201.703735 C 336.13501 188.321228 333.337585 169.584961 330.753784 159.776611 C 328.868774 158.78833 326.990967 157.850464 325.120239 156.962891 C 327.243225 171.759583 325.531189 188.003357 307.93576 188.513367 C 280.277679 189.314941 276.155792 153.981689 275.540344 143.420898 C 273.535339 143.248657 271.551697 143.125488 269.58432 143.038696 C 260.813568 182.145874 285.323273 201.703735 285.323273 201.703735 L 308.877747 193.224121 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.2,
    d: "M 308.877747 193.224121 L 324.894409 201.703735 C 336.13501 188.321228 333.337585 169.584961 330.753784 159.776611 C 328.868774 158.78833 326.990967 157.850464 325.120239 156.962891 C 327.243225 171.759583 325.531189 188.003357 307.93576 188.513367 C 280.277679 189.314941 276.155792 153.981689 275.540344 143.420898 C 273.535339 143.248657 271.551697 143.125488 269.58432 143.038696 C 260.813568 182.145874 285.323273 201.703735 285.323273 201.703735 L 308.877747 193.224121 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 377.221863 80.297485 C 392.4552 90.158325 387.94165 114.916626 372.058289 125.099121 C 367.534546 96.737427 377.221863 80.297485 377.221863 80.297485 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fill: "#000000",
    stroke: "none",
    opacity: 0.4,
    d: "M 377.221863 80.297485 C 392.4552 90.158325 387.94165 114.916626 372.058289 125.099121 C 367.534546 96.737427 377.221863 80.297485 377.221863 80.297485 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    fill: "#fdb473",
    stroke: "none",
    d: "M 307.376282 96.572021 C 301.661346 122.668335 296.968781 137.595825 306.012146 154.845825 C 314.712708 171.923767 335.611145 178.714966 352.688782 170.013733 C 358.973389 166.811707 364.133911 161.770874 367.481689 155.5625 C 379.488281 134.345093 386.843018 95.237915 364.969055 77.070435 C 350.396912 64.2771 328.212646 65.719482 315.419708 80.292114 C 311.357819 84.919556 308.583771 90.533813 307.376282 96.572021 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 304.625641 120.935425 C 318.568085 128.080811 327.550415 103.619995 325.612549 91.82373 C 343.751221 104.234131 384.492188 102.436646 396.416382 85.865479 C 409.443359 67.757813 389.877502 52.424561 372.186462 46.901245 C 367.276184 45.368408 362.624268 48.789551 361.397461 53.7854 C 361.182861 54.657593 360.748474 55.375366 360.12085 55.825317 C 360.12085 55.825317 355.113892 51.25708 347.984009 47.283691 C 341.878418 43.881348 334.693604 45.820068 329.531006 50.532104 C 327.477173 52.407104 322.447876 52.805054 312.361847 49.398315 C 291.446106 42.33374 287.924377 65.092041 298.080627 69.492554 C 288.877533 75.105469 273.650299 90.58667 281.854431 104.175903 C 290.058563 117.765015 297.110168 135.696167 292.505066 138.669189 C 296.759216 140.513306 304.27774 135.950439 304.625641 120.935425 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    fill: "#fdb473",
    stroke: "none",
    d: "M 291.598694 115.089233 C 291.710602 121.058716 294.072662 126.765381 298.21286 131.067505 C 303.684662 136.641602 309.963165 132.442871 311.373077 125.094482 C 312.644623 118.429688 311.312042 107.560425 304.393707 104.78125 C 297.474335 102.001587 291.525452 107.70752 291.598694 115.089233 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 343.723755 116.141724 C 343.111328 118.210449 343.753235 120.241211 345.135681 120.564209 C 346.518127 120.887085 348.039917 119.664185 348.652344 117.595337 C 349.265747 115.526611 348.638062 113.465454 347.210876 113.158325 C 345.782654 112.851685 344.306641 114.05835 343.723755 116.141724 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 367.008667 123.662476 C 366.39624 125.731689 367.007629 127.747559 368.420593 128.084961 C 369.834595 128.422852 371.324829 127.185425 371.951477 125.086304 C 372.579102 122.986694 371.922974 120.986206 370.51001 120.648804 C 369.097046 120.311279 367.605774 121.548828 367.008667 123.662476 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fill: "#ed883e",
    stroke: "none",
    d: "M 359.297852 122.304565 C 359.946899 129.484131 361.539917 136.546997 364.036255 143.30957 C 359.433167 145.571655 353.635864 142.09082 353.635864 142.09082 L 359.297852 122.304565 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 338.687317 106.202148 C 338.485901 106.161255 338.296692 106.070801 338.138 105.940063 C 337.711792 105.395874 337.805359 104.609131 338.349609 104.182495 C 338.363831 104.171265 338.379089 104.1604 338.393311 104.149902 C 341.613953 101.608765 345.889465 100.839111 349.793701 102.097534 C 350.440674 102.342529 350.765137 103.06543 350.52002 103.71167 C 350.514893 103.724243 350.509827 103.736328 350.504761 103.748779 C 350.259583 104.394653 349.536316 104.719604 348.890381 104.474243 C 348.878174 104.469604 348.864929 104.464478 348.85376 104.459595 C 345.814209 103.509155 342.500977 104.093384 339.970093 106.027588 C 339.615051 106.334961 339.112549 106.40332 338.687317 106.202148 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 379.312317 118.779907 C 378.928833 118.609985 378.659241 118.254517 378.599243 117.8396 C 378.141479 114.568359 376.188354 111.695435 373.313599 110.067993 C 372.731689 109.662476 372.58728 108.861206 372.993164 108.278687 C 373.308472 107.825806 373.877136 107.624634 374.407104 107.778687 L 374.407104 107.778687 C 378.017334 109.758301 380.482178 113.325073 381.056885 117.401733 C 381.178955 118.082153 380.726318 118.732178 380.045776 118.854248 C 380.038635 118.85498 380.031494 118.856201 380.024414 118.85791 C 379.784302 118.9104 379.534058 118.883301 379.312317 118.779907 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 341.884521 149.012451 C 343.044189 149.352051 344.230347 149.591675 345.430664 149.727905 C 345.816223 149.792969 346.18042 149.532837 346.245483 149.147095 C 346.247559 149.138672 346.248535 149.130859 346.249573 149.122559 C 346.272949 148.724609 345.983032 148.377563 345.587341 148.330322 C 339.446167 147.674683 333.981506 144.143799 330.858521 138.814941 C 330.685608 138.45752 330.25531 138.307861 329.897217 138.481689 C 329.539185 138.655029 329.390625 139.085449 329.563599 139.442871 C 332.210449 144.165894 336.653809 147.617554 341.884521 149.012451 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fill: "#263237",
    stroke: "none",
    d: "M 301.433502 70.45459 C 301.433502 70.45459 292.574249 68.98584 289.149139 58.48877 C 288.35672 56.05957 284.948914 55.861206 283.853333 58.17041 C 280.283783 65.699951 278.6745 76.114624 301.433502 70.45459 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    fill: "#007cff",
    stroke: "none",
    d: "M 477.488403 102.33667 L 465.538696 102.33667 C 455.201416 102.33667 446.07666 110.717041 445.158081 121.054565 L 434.789185 237.778809 C 433.870605 248.116638 441.506104 256.497131 451.843445 256.497131 L 463.793091 256.497131 L 477.488403 102.33667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 477.488403 102.33667 L 465.538696 102.33667 C 455.201416 102.33667 446.07666 110.717041 445.158081 121.054565 L 434.789185 237.778809 C 433.870605 248.116638 441.506104 256.497131 451.843445 256.497131 L 463.793091 256.497131 L 477.488403 102.33667 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    fill: "#007cff",
    stroke: "none",
    d: "M 654.927734 256.497131 L 460.008911 256.497131 C 449.671631 256.497131 442.036133 248.116638 442.953674 237.778809 L 453.323547 121.054565 C 454.242126 110.717041 463.366882 102.33667 473.704224 102.33667 L 668.623047 102.33667 C 678.960327 102.33667 686.595825 110.717041 685.678284 121.054565 L 675.308411 237.778809 C 674.389832 248.116638 665.265076 256.497131 654.927734 256.497131 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 654.927734 256.497131 L 460.008911 256.497131 C 449.671631 256.497131 442.036133 248.116638 442.953674 237.778809 L 453.323547 121.054565 C 454.242126 110.717041 463.366882 102.33667 473.704224 102.33667 L 668.623047 102.33667 C 678.960327 102.33667 686.595825 110.717041 685.678284 121.054565 L 675.308411 237.778809 C 674.389832 248.116638 665.265076 256.497131 654.927734 256.497131 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 567.762451 168.11084 C 567.762451 167.112061 567.93335 166.161682 568.176453 165.239502 C 566.938477 164.902588 565.660767 164.664551 564.315979 164.664551 C 556.167786 164.664551 549.563782 171.269531 549.563782 179.416748 C 549.563782 187.564148 556.167786 194.169189 564.315979 194.169189 C 572.464172 194.169189 579.068176 187.564148 579.068176 179.416748 C 572.823242 179.416748 567.762451 174.35498 567.762451 168.11084 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 555.430298 312.474121 L 570.429688 312.474121 L 564.492981 244.619568 C 564.155273 240.760864 560.924438 237.800049 557.050781 237.800049 L 557.050781 237.800049 C 552.667419 237.800049 549.226074 241.555481 549.607544 245.921997 L 555.430298 312.474121 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 555.430298 312.474121 L 570.429688 312.474121 L 564.492981 244.619568 C 564.155273 240.760864 560.924438 237.800049 557.050781 237.800049 L 557.050781 237.800049 C 552.667419 237.800049 549.226074 241.555481 549.607544 245.921997 L 555.430298 312.474121 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path63",
    fill: "#007cff",
    stroke: "none",
    d: "M 602.781372 332.148804 C 602.781372 310.416626 585.164551 292.799194 563.432007 292.799194 C 541.699402 292.799194 524.082642 310.416626 524.082642 332.148804 L 602.781372 332.148804 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 602.781372 332.148804 C 602.781372 310.416626 585.164551 292.799194 563.432007 292.799194 C 541.699402 292.799194 524.082642 310.416626 524.082642 332.148804 L 602.781372 332.148804 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path65",
    fill: "#007cff",
    stroke: "none",
    d: "M 510.32428 332.148804 L 448.17627 332.148804 C 444.073669 332.148804 440.747253 328.822876 440.747253 324.719543 L 440.747253 324.719543 C 440.747253 320.616699 444.073669 317.290405 448.17627 317.290405 L 510.32428 317.290405 C 514.427856 317.290405 517.753296 320.616699 517.753296 324.719543 L 517.753296 324.719543 C 517.753296 328.822876 514.427856 332.148804 510.32428 332.148804 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 510.32428 332.148804 L 448.17627 332.148804 C 444.073669 332.148804 440.747253 328.822876 440.747253 324.719543 L 440.747253 324.719543 C 440.747253 320.616699 444.073669 317.290405 448.17627 317.290405 L 510.32428 317.290405 C 514.427856 317.290405 517.753296 320.616699 517.753296 324.719543 L 517.753296 324.719543 C 517.753296 328.822876 514.427856 332.148804 510.32428 332.148804 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path67",
    fill: "#007cff",
    stroke: "none",
    d: "M 452.018433 332.148804 L 389.870361 332.148804 C 385.767822 332.148804 382.441406 328.822876 382.441406 324.719543 L 382.441406 324.719543 C 382.441406 320.616699 385.767822 317.290405 389.870361 317.290405 L 452.018433 317.290405 C 456.120972 317.290405 459.447388 320.616699 459.447388 324.719543 L 459.447388 324.719543 C 459.447388 328.822876 456.120972 332.148804 452.018433 332.148804 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 452.018433 332.148804 L 389.870361 332.148804 C 385.767822 332.148804 382.441406 328.822876 382.441406 324.719543 L 382.441406 324.719543 C 382.441406 320.616699 385.767822 317.290405 389.870361 317.290405 L 452.018433 317.290405 C 456.120972 317.290405 459.447388 320.616699 459.447388 324.719543 L 459.447388 324.719543 C 459.447388 328.822876 456.120972 332.148804 452.018433 332.148804 Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Character-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fill: "#007cff",
    stroke: "none",
    d: "M 972.109131 256.189514 C 968.606812 256.121643 965.087036 257.689209 962.743286 261.58667 C 917.878418 336.195801 901.939087 425.881287 917.418579 511.450745 C 918.388062 516.812439 922.059326 519.311707 926.134399 519.589539 C 932.924561 520.052917 1053.825073 519.624512 1058.210449 519.615356 C 1064.803223 519.602539 1072.047119 513.998718 1070.498901 505.439575 C 1056.113892 425.922485 1071.95459 342.162903 1113.544922 272.999146 C 1118.712524 264.404114 1111.091309 256.338318 1103.384644 256.189514 C 1099.882202 256.121643 979.814819 256.338318 972.109131 256.189514 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 972.109131 256.189514 C 968.606812 256.121643 965.087036 257.689209 962.743286 261.58667 C 917.878418 336.195801 901.939087 425.881287 917.418579 511.450745 C 918.388062 516.812439 922.059326 519.311707 926.134399 519.589539 C 932.924561 520.052917 1053.825073 519.624512 1058.210449 519.615356 C 1064.803223 519.602539 1072.047119 513.998718 1070.498901 505.439575 C 1056.113892 425.922485 1071.95459 342.162903 1113.544922 272.999146 C 1118.712524 264.404114 1111.091309 256.338318 1103.384644 256.189514 C 1099.882202 256.121643 979.814819 256.338318 972.109131 256.189514 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path71",
    fill: "#007cff",
    stroke: "none",
    d: "M 1070.498901 505.439575 C 1056.113892 425.922974 1071.953491 342.162903 1113.543945 272.999146 C 1121.062378 260.49707 1101.517944 249.115845 1094.019775 261.58667 C 1049.154907 336.195801 1033.214478 425.881287 1048.694092 511.450745 C 1051.280884 525.748413 1073.077637 519.690796 1070.498901 505.439575 L 1070.498901 505.439575 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1070.498901 505.439575 C 1056.113892 425.922974 1071.953491 342.162903 1113.543945 272.999146 C 1121.062378 260.49707 1101.517944 249.115845 1094.019775 261.58667 C 1049.154907 336.195801 1033.214478 425.881287 1048.694092 511.450745 C 1051.280884 525.748413 1073.077637 519.690796 1070.498901 505.439575 L 1070.498901 505.439575 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path73",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 996.382813 819.493774 L 891.357666 780.819641 L 785.188965 819.524536 C 781.523804 820.860718 777.64502 818.146973 777.64502 814.2453 L 777.64502 814.2453 C 777.64502 812.057983 778.914551 810.069214 780.899231 809.148315 L 891.357666 757.896606 L 1000.704102 809.143799 C 1002.676636 810.067932 1003.935913 812.048828 1003.935913 814.226196 L 1003.935913 814.226196 C 1003.935913 818.131226 1000.047974 820.842896 996.382813 819.493774 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 996.382813 819.493774 L 891.357666 780.819641 L 785.188965 819.524536 C 781.523804 820.860718 777.64502 818.146973 777.64502 814.2453 L 777.64502 814.2453 C 777.64502 812.057983 778.914551 810.069214 780.899231 809.148315 L 891.357666 757.896606 L 1000.704102 809.143799 C 1002.676636 810.067932 1003.935913 812.048828 1003.935913 814.226196 L 1003.935913 814.226196 C 1003.935913 818.131226 1000.047974 820.842896 996.382813 819.493774 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 866.60791 789.842163 L 891.357666 780.819641 L 914.973145 789.515381 L 914.973145 768.964111 L 891.357666 757.896606 L 866.60791 769.380371 L 866.60791 789.842163 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 890.790039 820.390503 L 890.790039 820.390503 C 885.982422 820.390503 881.963257 816.735535 881.507568 811.949097 L 878.542236 780.816589 L 878.542236 522.412537 L 903.038696 522.412537 L 903.038696 780.816589 L 900.073486 811.949097 C 899.617676 816.735535 895.598511 820.390503 890.790039 820.390503 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 890.790039 820.390503 L 890.790039 820.390503 C 885.982422 820.390503 881.963257 816.735535 881.507568 811.949097 L 878.542236 780.816589 L 878.542236 522.412537 L 903.038696 522.412537 L 903.038696 780.816589 L 900.073486 811.949097 C 899.617676 816.735535 895.598511 820.390503 890.790039 820.390503 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 878.542236 552.503662 L 903.038696 552.503662 L 903.038696 522.412537 L 878.542236 522.412537 L 878.542236 552.503662 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path79",
    fill: "#007cff",
    stroke: "none",
    d: "M 697.254639 498.892517 C 724.969666 491.824524 753.447632 487.938354 782.00293 487.222107 C 811.433105 486.484192 921.590332 487.111206 947.751099 487.100769 C 979.594116 487.088318 1011.437134 491.013794 1042.332153 498.892517 C 1061.75354 503.845032 1055.766968 531.872009 1038.225464 532.196777 C 1036.67627 532.225464 703.6745 532.124512 702.450745 532.179932 C 684.100525 533.014099 677.40802 503.954102 697.254639 498.892517 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    fill: "#000000",
    stroke: "none",
    opacity: 0.3,
    d: "M 697.254639 498.892517 C 724.969666 491.824524 753.447632 487.938354 782.00293 487.222107 C 811.433105 486.484192 921.590332 487.111206 947.751099 487.100769 C 979.594116 487.088318 1011.437134 491.013794 1042.332153 498.892517 C 1061.75354 503.845032 1055.766968 531.872009 1038.225464 532.196777 C 1036.67627 532.225464 703.6745 532.124512 702.450745 532.179932 C 684.100525 533.014099 677.40802 503.954102 697.254639 498.892517 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path81",
    fill: "#007cff",
    stroke: "none",
    d: "M 1033.315186 531.598877 C 977.377563 517.333313 918.12561 517.333801 862.18689 531.598877 C 841.026978 536.995361 831.999878 504.291199 853.169922 498.892517 C 914.956909 483.135437 980.545288 483.135437 1042.332153 498.892517 C 1063.469604 504.282959 1054.511719 537.004272 1033.315186 531.598877 L 1033.315186 531.598877 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g35",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1033.315186 531.598877 C 977.377563 517.333313 918.12561 517.333801 862.18689 531.598877 C 841.026978 536.995361 831.999878 504.291199 853.169922 498.892517 C 914.956909 483.135437 980.545288 483.135437 1042.332153 498.892517 C 1063.469604 504.282959 1054.511719 537.004272 1033.315186 531.598877 L 1033.315186 531.598877 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path83",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 871.824341 117.333252 C 871.824341 117.333252 851.344971 115.345825 857.705933 84.894653 C 864.064697 54.443848 863.525635 25.515015 908.78418 28.79126 C 908.78418 28.79126 944.619995 19.818726 954.748779 53.501221 C 964.877563 87.184204 979.924683 111.059082 955.926758 120.952515 C 925.915771 133.324585 918.343262 105.791626 918.343262 105.791626 L 874.452881 110.044189 L 871.824341 117.333252 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 865.113525 161.931641 C 838.960938 158.195435 851.807861 248.677917 828.369324 264.952515 C 815.508179 273.881714 750.743774 249.907104 750.743774 249.907104 L 741.617004 220.696716 C 741.142944 219.178711 740.022949 217.961182 738.570313 217.383362 L 725.08667 212.02002 C 721.223145 210.483765 717.253784 213.995422 718.18457 218.126221 L 723.042969 239.677856 C 723.252563 240.610046 723.706238 241.46582 724.355225 242.154602 L 743.146973 262.107544 C 743.146973 262.107544 820.370667 299.562927 839.204102 293.345825 C 861.030273 286.140869 869.126587 246.389587 874.535278 222.701721 C 878.56665 205.047913 884.899048 164.758362 865.113525 161.931641 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 834.975342 702.950439 L 842.815308 763.82666 L 820.678894 764.403198 L 804.690735 705.67926 L 834.975342 702.950439 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 820.394043 761.023682 L 845.666748 761.100464 C 846.762329 761.103271 847.708374 761.864136 847.945313 762.933289 L 853.132324 786.57373 C 853.608398 788.667969 852.296143 790.750305 850.202637 791.225342 C 849.934082 791.286621 849.6604 791.319214 849.383789 791.322021 C 838.91626 791.112427 829.608337 790.514038 816.573242 790.498291 C 801.192383 790.462402 805.089478 792.312805 787.005798 792.522583 C 776.109985 792.637573 774.148743 780.247925 778.769104 779.650024 C 799.920837 777.044067 805.902283 770.665405 814.078979 763.118652 C 815.856079 761.67041 818.10321 760.924438 820.394043 761.023682 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 813.963989 739.741943 L 804.690735 705.67926 L 834.975342 702.950439 L 839.508301 738.14209 L 813.963989 739.741943 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 911.24292 337.520813 L 875.477295 337.520813 C 875.477295 337.520813 866.055542 361.890869 864.171509 387.329163 C 862.287598 412.767883 911.24292 393.9245 911.24292 393.9245 L 915.520386 359.064148 L 911.24292 337.520813 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 683.274536 618.632202 L 659.721069 687.4104 L 639.935486 681.757568 L 655.952148 609.210388 L 683.274536 618.632202 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 640.283386 676.473389 L 664.613037 683.814209 C 665.672974 684.090332 666.399292 685.064087 666.360657 686.157959 L 665.468506 710.344849 C 665.405457 712.491333 663.613037 714.179688 661.467651 714.115845 C 661.192017 714.107422 660.918335 714.070068 660.650818 714.004211 C 650.56781 711.182129 641.705505 708.274292 629.089539 704.997437 C 614.207153 701.114075 617.517273 703.880737 599.956421 699.559204 C 589.378052 696.94458 590.578369 684.457886 595.20282 685.0354 C 616.334229 687.804565 623.840515 682.182495 633.644775 676.921753 C 635.728149 675.963745 638.09021 675.804077 640.283386 676.473389 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 670.433716 656.130432 L 646.924011 650.102905 L 655.952148 609.210388 L 683.274536 618.632202 L 670.433716 656.130432 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 982.570557 334.253784 C 982.570557 334.253784 1019.001465 395.180847 1012.719971 446.05835 C 1006.439453 496.935486 959.376221 523.846619 778.480225 437.167053 C 778.480225 437.167053 741.374878 475.579163 679.819946 640.14502 L 648.414307 630.723267 C 648.414307 630.723267 683.902161 440.498779 715.622131 386.387085 C 747.656433 331.741272 888.353638 395.808716 899.031738 385.131287 C 908.536987 375.626282 900.288086 338.022522 900.288086 338.022522 L 982.570557 334.253784 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    fill: "#007cff",
    stroke: "none",
    d: "M 687.514404 637.004272 L 680.919556 649.723755 L 643.232422 637.004272 L 643.232422 622.400879 L 687.514404 637.004272 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    fill: "#007cff",
    stroke: "none",
    d: "M 997.245483 171.426697 L 869.093994 161.845459 C 861.337524 161.265381 854.917603 167.788391 855.619507 175.534119 C 855.619507 175.534119 858.249146 191.655029 857.800537 197.040344 C 856.669312 210.628296 849.362427 230.970825 851.798706 240.23291 C 853.750854 247.658752 861.557251 256.095825 864.640503 264.449646 C 871.326904 282.563721 872.437744 341.289612 872.437744 341.289612 C 913.893799 348.010803 987.595825 338.022522 987.595825 338.022522 C 971.059326 278.402527 995.78064 208.700012 1003.355103 179.968689 C 1004.44458 175.835876 1001.507813 171.745361 997.245483 171.426697 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.7,
    d: "M 997.245483 171.426697 L 869.093994 161.845459 C 861.337524 161.265381 854.917603 167.788391 855.619507 175.534119 C 855.619507 175.534119 858.249146 191.655029 857.800537 197.040344 C 856.669312 210.628296 849.362427 230.970825 851.798706 240.23291 C 853.750854 247.658752 861.557251 256.095825 864.640503 264.449646 C 871.326904 282.563721 872.437744 341.289612 872.437744 341.289612 C 913.893799 348.010803 987.595825 338.022522 987.595825 338.022522 C 971.059326 278.402527 995.78064 208.700012 1003.355103 179.968689 C 1004.44458 175.835876 1001.507813 171.745361 997.245483 171.426697 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 978.160767 241.815002 L 933.878784 287.159546 L 870.753174 299.878784 L 870.328979 299.981262 C 870.910889 306.966187 871.338135 313.946716 871.652466 320.142578 C 889.139038 320.112549 946.182495 318.895813 962.614136 304.589539 C 970.775513 297.484497 977.546387 286.833374 982.669312 276.848267 C 983.441406 266.435791 984.846191 256.230835 986.606079 246.486755 L 978.160767 241.815002 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 757.835083 454.237549 L 747.942261 446.588684 C 747.942261 446.588684 713.071899 465.463318 730.428223 519.207458 C 730.42926 519.209229 730.42926 519.210876 730.42926 519.210876 C 743.03302 492.904236 753.387634 474.361206 761.215393 461.65332 L 757.835083 454.237549 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 908.928589 487.199219 C 876.055054 479.327942 833.486084 463.523804 778.480225 437.167053 C 778.480225 437.167053 736.036377 437.735413 733.210449 469.297852 C 730.383484 500.860779 804.814819 719.136963 804.814819 719.136963 L 839.204102 716.14679 C 839.204102 716.14679 818.94751 498.505493 814.236633 487.199219 L 908.928589 487.199219 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 778.480225 437.167053 C 778.480225 437.167053 771.995239 437.262939 763.933472 439.25 C 771.705322 446.142517 799.125366 468.941711 840.646606 487.199219 L 908.928589 487.199219 C 876.055054 479.327942 833.486084 463.523804 778.480225 437.167053 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    fill: "#007cff",
    stroke: "none",
    d: "M 843.329102 710.502808 L 844.254761 724.627075 L 804.22583 727.771179 L 798.53125 714.323853 L 843.329102 710.502808 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 936.752563 111.744629 L 908.78418 139.224609 C 913.47876 161.809204 896.90271 163.924622 896.90271 163.924622 C 896.90271 163.924622 898.240356 171.866699 918.518311 170.783813 C 938.795166 169.700806 945.419556 167.551636 945.419556 167.551636 C 933.227783 157.799561 934.968262 128.0979 936.752563 111.744629 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 909.037476 151.941284 C 909.787231 148.65918 909.885864 144.522949 908.78418 139.224609 L 933.735352 114.707886 L 936.18689 117.546631 C 936.18689 117.546631 931.166748 148.780029 909.037476 151.941284 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 939.087158 75.36792 C 941.128784 102.306274 942.584473 113.6604 930.993896 129.223267 C 913.555054 152.647949 880.037598 149.281616 869.967896 123.503662 C 860.910278 100.30127 859.078125 60.178345 883.733276 45.934937 C 901.299194 35.667847 923.861938 41.584961 934.129028 59.150391 C 937.02002 64.097046 938.717896 69.649902 939.087158 75.36792 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    fill: "#b94d3c",
    stroke: "none",
    d: "M 884.12085 102.602417 C 882.875732 107.832886 880.916504 112.867554 878.297119 117.563354 C 880.752808 118.868286 883.660034 119.018799 886.236816 117.974121 L 884.12085 102.602417 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    fill: "#263237",
    stroke: "none",
    d: "M 904.501587 84.227417 C 904.676514 84.15918 904.83313 84.051758 904.959351 83.912964 C 905.339722 83.460815 905.281738 82.7854 904.829102 82.404541 C 904.823975 82.399902 904.817871 82.395874 904.812866 82.391235 C 901.75293 79.694946 897.569946 78.658691 893.605713 79.614136 C 893.052368 79.803833 892.744141 80.393799 892.903809 80.956177 C 893.076782 81.510864 893.659668 81.825806 894.21814 81.66748 C 897.503906 80.932007 900.944214 81.817993 903.465942 84.049561 C 903.755859 84.286255 904.149536 84.35376 904.501587 84.227417 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    fill: "#263237",
    stroke: "none",
    d: "M 864.696411 87.937134 C 864.870361 87.868286 865.028076 87.760864 865.154175 87.622192 C 867.317871 85.063354 870.577148 83.696289 873.918823 83.944092 C 874.501709 84.040405 875.053101 83.645386 875.148682 83.0625 C 875.14978 83.057495 875.150757 83.052856 875.151733 83.04834 C 875.224976 82.45752 874.815063 81.91626 874.227051 81.825439 C 870.165161 81.472412 866.182617 83.101685 863.531738 86.199097 C 863.122803 86.625366 863.135986 87.303711 863.562256 87.712891 C 863.86438 88.002441 864.306885 88.089966 864.696411 87.937134 L 864.696411 87.937134 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path107",
    fill: "#263237",
    stroke: "none",
    d: "M 898.977905 96.889893 C 899.281006 99.049561 898.369507 100.967529 896.932129 101.179199 C 895.49585 101.390381 894.126587 99.786743 893.841797 97.589233 C 893.556885 95.391602 894.450073 93.511597 895.859009 93.30957 C 897.267822 93.10791 898.664551 94.702026 898.977905 96.889893 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    fill: "#263237",
    stroke: "none",
    d: "M 874.393921 100.290894 C 874.697021 102.450317 873.785645 104.368286 872.376709 104.569946 C 870.968872 104.771606 869.570068 103.17749 869.257813 100.98999 C 868.944458 98.802124 869.866089 96.912476 871.275024 96.710449 C 872.682861 96.508667 874.110107 98.093384 874.393921 100.290894 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    fill: "#263237",
    stroke: "none",
    d: "M 871.914917 96.741699 L 866.490845 95.967896 C 866.490845 95.967896 869.743042 99.65918 871.914917 96.741699 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    fill: "#263237",
    stroke: "none",
    d: "M 896.498779 93.34082 L 891.074829 92.567139 C 891.074829 92.567139 894.327026 96.258789 896.498779 93.34082 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 900.687866 118.936646 C 901.126343 118.170898 901.497559 117.369141 901.798706 116.539551 C 901.910645 116.2771 901.787476 115.973755 901.525024 115.862061 C 901.518921 115.859497 901.512817 115.857178 901.507813 115.85498 C 901.230103 115.770386 900.932983 115.91748 900.833374 116.19043 C 899.322754 120.441284 895.885376 123.7229 891.569214 125.034546 C 891.2854 125.097046 891.106323 125.377441 891.168457 125.660767 C 891.231445 125.94458 891.51123 126.123779 891.795044 126.061157 C 895.599609 124.985107 898.807007 122.414917 900.687866 118.936646 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 918.343262 36.135376 C 901.044922 31.831665 883.143311 40.894165 883.143311 40.894165 C 883.143311 40.894165 863.115601 58.68335 867.712646 75.87793 C 867.712646 75.87793 869.987183 73.937012 874.769287 72.490845 C 874.503784 67.821167 874.87915 59.65625 879.846436 54.207886 C 879.846436 54.207886 877.912598 63.579956 880.481201 71.310303 C 886.465698 70.541138 894.615845 70.867432 905.211548 74.229126 C 905.211548 74.229126 908.670288 67.098755 905.211548 51.617065 C 905.211548 51.617065 911.879639 61.980835 912.115723 77.997925 C 912.351685 94.014526 932.843262 97.864258 932.843262 97.864258 C 932.843262 97.864258 945.710449 96.486206 945.564941 79.265747 C 945.419556 62.044922 935.641724 40.439575 918.343262 36.135376 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 910.702759 35.12915 C 910.702759 35.12915 902.520996 14.872559 886.236816 19.818726 C 869.953613 24.765503 898.453979 24.765503 910.702759 35.12915 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 948.321777 95.615845 C 947.526245 100.779175 944.709473 105.414185 940.49292 108.499634 C 934.872681 112.541626 929.694824 108.0979 929.26355 101.54834 C 928.876953 95.675415 931.334595 86.464111 937.939697 85.007935 C 942.780762 84.094116 947.445923 87.27832 948.359375 92.119141 C 948.578125 93.275757 948.564819 94.4646 948.321777 95.615845 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 998.861938 170.840027 C 986.126953 166.489624 968.668823 215.28418 961.343628 230.470825 C 958.322388 236.73584 953.485352 250.833313 949.830322 261.9729 C 946.629028 271.728333 938.938599 279.199158 929.296021 281.931641 L 860.995728 301.289917 L 833.240967 292.946289 C 831.163696 292.322083 828.925781 292.671265 827.121155 293.901611 L 813.177673 303.4104 C 811.121826 304.812561 809.885864 307.182129 809.885864 309.720825 L 809.885864 309.720825 C 809.885864 314.129211 813.529663 317.605042 817.798035 317.267944 L 859.042603 314.012085 C 859.042603 314.012085 925.541382 317.889221 954.748779 301.585815 C 983.956055 285.282959 1021.014648 178.407837 998.861938 170.840027 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 945.704346 317.416199 L 709.026245 317.416199 C 705.456726 317.416199 702.561646 320.310791 702.561646 323.881226 C 702.561646 327.45166 705.456726 330.346252 709.026245 330.346252 L 945.704346 330.346252 C 949.274902 330.346252 952.170044 327.45166 952.170044 323.881226 C 952.170044 320.310791 949.274902 317.416199 945.704346 317.416199 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 945.704346 317.416199 L 709.026245 317.416199 C 705.456726 317.416199 702.561646 320.310791 702.561646 323.881226 C 702.561646 327.45166 705.456726 330.346252 709.026245 330.346252 L 945.704346 330.346252 C 949.274902 330.346252 952.170044 327.45166 952.170044 323.881226 C 952.170044 320.310791 949.274902 317.416199 945.704346 317.416199 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path118",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 712.540894 326.393677 L 793.442993 326.393677 C 795.55072 326.393677 797.028809 324.311646 796.33197 322.321228 L 751.967529 195.581238 C 750.744812 192.089539 747.449951 189.752136 743.750183 189.752136 L 662.849121 189.752136 C 660.740356 189.752136 659.263306 191.834167 659.960083 193.824585 L 704.324524 320.564209 C 705.546265 324.055786 708.842163 326.393677 712.540894 326.393677 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path119",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 712.540894 326.393677 L 793.442993 326.393677 C 795.55072 326.393677 797.028809 324.311646 796.33197 322.321228 L 751.967529 195.581238 C 750.744812 192.089539 747.449951 189.752136 743.750183 189.752136 L 662.849121 189.752136 C 660.740356 189.752136 659.263306 191.834167 659.960083 193.824585 L 704.324524 320.564209 C 705.546265 324.055786 708.842163 326.393677 712.540894 326.393677 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 708.637695 326.393677 L 789.538757 326.393677 C 791.647522 326.393677 793.124573 324.311646 792.428772 322.321228 L 748.063354 195.581238 C 746.841614 192.089539 743.545715 189.752136 739.846985 189.752136 L 658.945923 189.752136 C 656.837158 189.752136 655.360107 191.834167 656.055908 193.824585 L 700.421326 320.564209 C 701.643066 324.055786 704.938965 326.393677 708.637695 326.393677 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    fill: "#ffffff",
    stroke: "none",
    d: "M 717.68103 258.072876 C 718.713562 262.929199 722.07251 266.866211 725.183289 266.866211 C 728.294067 266.866211 729.979614 262.929199 728.947144 258.072876 C 727.914612 253.216614 724.556641 249.279602 721.444885 249.279602 C 718.334106 249.279602 716.64856 253.216614 717.68103 258.072876 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.2,
    d: "M 803.83728 330.346252 C 800.266724 330.346252 797.371582 327.45166 797.371582 323.881226 C 797.371582 320.310791 800.266724 317.416199 803.83728 317.416199 L 945.704346 317.416199 C 949.274902 317.416199 952.170044 320.310791 952.170044 323.881226 C 952.170044 327.45166 949.274902 330.346252 945.704346 330.346252 L 803.83728 330.346252 Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path123",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1508.578735 819.487427 L 1508.578735 819.487427 C 1513.4646 819.487427 1517.352539 815.39502 1517.102295 810.516541 L 1493.922119 358.367493 L 1469.425659 358.367493 L 1500.065308 811.529236 C 1500.367432 816.008667 1504.0896 819.487427 1508.578735 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1508.578735 819.487427 L 1508.578735 819.487427 C 1513.4646 819.487427 1517.352539 815.39502 1517.102295 810.516541 L 1493.922119 358.367493 L 1469.425659 358.367493 L 1500.065308 811.529236 C 1500.367432 816.008667 1504.0896 819.487427 1508.578735 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path125",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1493.922119 358.367493 L 1469.425659 358.367493 L 1471.464233 388.516663 L 1495.467285 388.516663 L 1493.922119 358.367493 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1166.144043 819.487427 L 1166.144043 819.487427 C 1161.259155 819.487427 1157.371216 815.39502 1157.620483 810.516541 L 1180.801636 358.367493 L 1205.296997 358.367493 L 1174.658447 811.529236 C 1174.355225 816.008667 1170.633179 819.487427 1166.144043 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1166.144043 819.487427 L 1166.144043 819.487427 C 1161.259155 819.487427 1157.371216 815.39502 1157.620483 810.516541 L 1180.801636 358.367493 L 1205.296997 358.367493 L 1174.658447 811.529236 C 1174.355225 816.008667 1170.633179 819.487427 1166.144043 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1179.255371 388.516663 L 1203.259521 388.516663 L 1205.296997 358.367493 L 1180.801636 358.367493 L 1179.255371 388.516663 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path129",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 620.898621 819.487427 L 620.898621 819.487427 C 625.782471 819.487427 629.67041 815.39502 629.421143 810.516541 L 606.241028 358.367493 L 581.744568 358.367493 L 612.384216 811.529236 C 612.68634 816.008667 616.408447 819.487427 620.898621 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 620.898621 819.487427 L 620.898621 819.487427 C 625.782471 819.487427 629.67041 815.39502 629.421143 810.516541 L 606.241028 358.367493 L 581.744568 358.367493 L 612.384216 811.529236 C 612.68634 816.008667 616.408447 819.487427 620.898621 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path131",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 606.241028 358.367493 L 581.744568 358.367493 L 583.783142 388.516663 L 607.786255 388.516663 L 606.241028 358.367493 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 278.462921 819.487427 L 278.462921 819.487427 C 273.578064 819.487427 269.689117 815.39502 269.940369 810.516541 L 293.120514 358.367493 L 317.615936 358.367493 L 286.977325 811.529236 C 286.674164 816.008667 282.952057 819.487427 278.462921 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 278.462921 819.487427 L 278.462921 819.487427 C 273.578064 819.487427 269.689117 815.39502 269.940369 810.516541 L 293.120514 358.367493 L 317.615936 358.367493 L 286.977325 811.529236 C 286.674164 816.008667 282.952057 819.487427 278.462921 819.487427 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 291.57428 388.516663 L 315.5784 388.516663 L 317.615936 358.367493 L 293.120514 358.367493 L 291.57428 388.516663 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1513.615112 358.367493 L 269.479553 358.367493 L 269.479553 344.040344 L 1513.615112 344.040344 L 1513.615112 358.367493 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 1513.615112 358.367493 L 269.479553 358.367493 L 269.479553 344.040344 L 1513.615112 344.040344 L 1513.615112 358.367493 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path137",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1513.615112 358.367493 L 1157.161621 358.367493 L 1157.161621 344.040344 L 1513.615112 344.040344 L 1513.615112 358.367493 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    fill: "#007cff",
    stroke: "none",
    d: "M 1545.649414 344.040344 L 237.446259 344.040344 L 237.446259 329.713745 L 1545.649414 329.713745 L 1545.649414 344.040344 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    fill: "#000000",
    stroke: "none",
    opacity: 0.3,
    d: "M 1545.649414 344.040344 L 1125.127319 344.040344 L 1125.127319 329.713745 L 1545.649414 329.713745 L 1545.649414 344.040344 Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    fill: "#007cff",
    stroke: "none",
    d: "M 1256.360107 330.346252 L 1194.213013 330.346252 C 1190.109497 330.346252 1186.784058 327.019958 1186.784058 322.917114 L 1186.784058 322.917114 C 1186.784058 318.813782 1190.109497 315.487854 1194.213013 315.487854 L 1256.360107 315.487854 C 1260.463623 315.487854 1263.790039 318.813782 1263.790039 322.917114 L 1263.790039 322.917114 C 1263.790039 327.019958 1260.463623 330.346252 1256.360107 330.346252 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path141",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 1256.360107 330.346252 L 1194.213013 330.346252 C 1190.109497 330.346252 1186.784058 327.019958 1186.784058 322.917114 L 1186.784058 322.917114 C 1186.784058 318.813782 1190.109497 315.487854 1194.213013 315.487854 L 1256.360107 315.487854 C 1260.463623 315.487854 1263.790039 318.813782 1263.790039 322.917114 L 1263.790039 322.917114 C 1263.790039 327.019958 1260.463623 330.346252 1256.360107 330.346252 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path142",
    fill: "#007cff",
    stroke: "none",
    d: "M 1198.054199 330.346252 L 1135.907227 330.346252 C 1131.803589 330.346252 1128.477173 327.019958 1128.477173 322.917114 L 1128.477173 322.917114 C 1128.477173 318.813782 1131.803589 315.487854 1135.907227 315.487854 L 1198.054199 315.487854 C 1202.157837 315.487854 1205.483154 318.813782 1205.483154 322.917114 L 1205.483154 322.917114 C 1205.483154 327.019958 1202.157837 330.346252 1198.054199 330.346252 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path143",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1198.054199 330.346252 L 1135.907227 330.346252 C 1131.803589 330.346252 1128.477173 327.019958 1128.477173 322.917114 L 1128.477173 322.917114 C 1128.477173 318.813782 1131.803589 315.487854 1135.907227 315.487854 L 1198.054199 315.487854 C 1202.157837 315.487854 1205.483154 318.813782 1205.483154 322.917114 L 1205.483154 322.917114 C 1205.483154 327.019958 1202.157837 330.346252 1198.054199 330.346252 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    fill: "#007cff",
    stroke: "none",
    d: "M 989.660889 104.700439 L 977.712158 104.700439 C 967.373901 104.700439 959.727173 113.080811 960.63147 123.418701 L 970.84375 240.142883 C 971.748047 250.480469 980.861572 258.86084 991.198975 258.86084 L 1003.14856 258.86084 L 989.660889 104.700439 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path145",
    fill: "#007cff",
    stroke: "none",
    d: "M 989.660889 104.700439 L 977.712158 104.700439 C 967.373901 104.700439 959.727173 113.080811 960.63147 123.418701 L 970.84375 240.142883 C 971.748047 250.480469 980.861572 258.86084 991.198975 258.86084 L 1003.14856 258.86084 L 989.660889 104.700439 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1090.801147 310.671326 L 1075.801758 310.671326 L 1082.334595 235.99707 L 1097.333984 235.99707 L 1090.801147 310.671326 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path147",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 1090.801147 310.671326 L 1075.801758 310.671326 L 1082.334595 235.99707 L 1097.333984 235.99707 L 1090.801147 310.671326 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path148",
    fill: "#007cff",
    stroke: "none",
    d: "M 1194.283203 258.86084 L 999.36438 258.86084 C 989.0271 258.86084 979.913574 250.480469 979.009155 240.142883 L 968.796997 123.418701 C 967.8927 113.081299 975.539307 104.700806 985.877686 104.700806 L 1180.795532 104.700806 C 1191.133789 104.700806 1200.246338 113.081299 1201.151733 123.418701 L 1211.362915 240.142883 C 1212.267212 250.480469 1204.620605 258.86084 1194.283203 258.86084 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path149",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1194.283203 258.86084 L 999.36438 258.86084 C 989.0271 258.86084 979.913574 250.480469 979.009155 240.142883 L 968.796997 123.418701 C 967.8927 113.081299 975.539307 104.700806 985.877686 104.700806 L 1180.795532 104.700806 C 1191.133789 104.700806 1200.246338 113.081299 1201.151733 123.418701 L 1211.362915 240.142883 C 1212.267212 250.480469 1204.620605 258.86084 1194.283203 258.86084 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1181.454712 112.23877 L 986.537842 112.23877 C 980.373291 112.23877 975.795654 117.255005 976.334839 123.419678 L 986.546997 240.143799 C 987.086182 246.30835 992.541748 251.322876 998.706299 251.322876 L 1193.623047 251.322876 C 1199.787598 251.322876 1204.365234 246.30835 1203.82605 240.143799 L 1193.613892 123.419678 C 1193.074707 117.255005 1187.619263 112.23877 1181.454712 112.23877 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path151",
    fill: "#007cff",
    stroke: "none",
    d: "M 1047.218018 330.346252 C 1047.218018 308.614136 1064.835815 290.996643 1086.567383 290.996643 C 1108.299927 290.996643 1125.916748 308.614136 1125.916748 330.346252 L 1047.218018 330.346252 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1047.218018 330.346252 C 1047.218018 308.614136 1064.835815 290.996643 1086.567383 290.996643 C 1108.299927 290.996643 1125.916748 308.614136 1125.916748 330.346252 L 1047.218018 330.346252 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path153",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1137.517456 140.925781 C 1135.874634 140.925781 1031.953125 140.925781 1030.309204 140.925781 C 1028.01123 140.925781 1026.310425 142.789185 1026.511841 145.087891 C 1026.713257 147.386597 1028.739624 149.25 1031.037598 149.25 C 1032.681519 149.25 1136.603027 149.25 1138.24585 149.25 C 1140.5448 149.25 1142.245728 147.386597 1142.044312 145.087891 C 1141.842896 142.789185 1139.816528 140.925781 1137.517456 140.925781 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1124.214844 158.372925 C 1122.571045 158.372925 1033.47998 158.372925 1031.836182 158.372925 C 1029.537109 158.372925 1027.83728 160.236328 1028.038696 162.535034 C 1028.239136 164.83374 1030.265503 166.697144 1032.564453 166.697144 C 1034.208374 166.697144 1123.299316 166.697144 1124.943237 166.697144 C 1127.241211 166.697144 1128.942017 164.83374 1128.740601 162.535034 C 1128.539185 160.236328 1126.512817 158.372925 1124.214844 158.372925 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path155",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1134.900146 175.819946 C 1133.257202 175.819946 1035.005859 175.819946 1033.362061 175.819946 C 1031.064087 175.819946 1029.363159 177.68335 1029.564575 179.982056 C 1029.765991 182.280823 1031.792358 184.144165 1034.090332 184.144165 C 1035.734253 184.144165 1133.985596 184.144165 1135.628418 184.144165 C 1137.92749 184.144165 1139.628296 182.280823 1139.42688 179.982056 C 1139.225464 177.68335 1137.199097 175.819946 1134.900146 175.819946 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1121.597534 193.267151 C 1119.953613 193.267151 1036.532837 193.267151 1034.888916 193.267151 C 1032.589966 193.267151 1030.890137 195.130493 1031.090454 197.429199 C 1031.29187 199.727966 1033.318237 201.591309 1035.61731 201.591309 C 1037.260132 201.591309 1120.682007 201.591309 1122.325806 201.591309 C 1124.623779 201.591309 1126.324707 199.727966 1126.123291 197.429199 C 1125.921875 195.130493 1123.895508 193.267151 1121.597534 193.267151 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g55",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "path157",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1137.517456 140.925781 C 1135.874634 140.925781 1031.953125 140.925781 1030.309204 140.925781 C 1028.01123 140.925781 1026.310425 142.789185 1026.511841 145.087891 C 1026.713257 147.386597 1028.739624 149.25 1031.037598 149.25 C 1032.681519 149.25 1136.603027 149.25 1138.24585 149.25 C 1140.5448 149.25 1142.245728 147.386597 1142.044312 145.087891 C 1141.842896 142.789185 1139.816528 140.925781 1137.517456 140.925781 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1124.214844 158.372925 C 1122.571045 158.372925 1033.47998 158.372925 1031.836182 158.372925 C 1029.537109 158.372925 1027.83728 160.236328 1028.038696 162.535034 C 1028.239136 164.83374 1030.265503 166.697144 1032.564453 166.697144 C 1034.208374 166.697144 1123.299316 166.697144 1124.943237 166.697144 C 1127.241211 166.697144 1128.942017 164.83374 1128.740601 162.535034 C 1128.539185 160.236328 1126.512817 158.372925 1124.214844 158.372925 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path159",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1134.900146 175.819946 C 1133.257202 175.819946 1035.005859 175.819946 1033.362061 175.819946 C 1031.064087 175.819946 1029.363159 177.68335 1029.564575 179.982056 C 1029.765991 182.280823 1031.792358 184.144165 1034.090332 184.144165 C 1035.734253 184.144165 1133.985596 184.144165 1135.628418 184.144165 C 1137.92749 184.144165 1139.628296 182.280823 1139.42688 179.982056 C 1139.225464 177.68335 1137.199097 175.819946 1134.900146 175.819946 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1121.597534 193.267151 C 1119.953613 193.267151 1036.532837 193.267151 1034.888916 193.267151 C 1032.589966 193.267151 1030.890137 195.130493 1031.090454 197.429199 C 1031.29187 199.727966 1033.318237 201.591309 1035.61731 201.591309 C 1037.260132 201.591309 1120.682007 201.591309 1122.325806 201.591309 C 1124.623779 201.591309 1126.324707 199.727966 1126.123291 197.429199 C 1125.921875 195.130493 1123.895508 193.267151 1121.597534 193.267151 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path161",
    fill: "#002a32",
    stroke: "none",
    d: "M 1355.15564 43.135376 C 1355.15564 43.135376 1330.504517 47.846313 1330.935913 32.77124 C 1331.365112 17.696655 1356.804565 24.762939 1356.804565 24.762939 L 1355.15564 43.135376 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    fill: "#000000",
    stroke: "none",
    opacity: 0.4,
    d: "M 1355.15564 43.135376 C 1355.15564 43.135376 1330.504517 47.846313 1330.935913 32.77124 C 1331.365112 17.696655 1356.804565 24.762939 1356.804565 24.762939 L 1355.15564 43.135376 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    fill: "#b94d3c",
    stroke: "none",
    d: "M 1339.732056 79.143311 L 1328.450684 96.872192 C 1328.450684 96.872192 1334.329468 101.210815 1342.55896 98.257935 L 1339.732056 79.143311 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    fill: "#002a32",
    stroke: "none",
    d: "M 1332.935791 76.673706 C 1332.911377 78.960815 1334.075073 80.83667 1335.574585 80.856201 C 1337.072998 80.875854 1338.408569 78.94165 1338.370972 76.717041 C 1338.334351 74.492432 1337.231689 72.554565 1335.728149 72.558838 C 1334.224609 72.563354 1332.983643 74.39209 1332.935791 76.673706 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path165",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1421.214966 62.384277 C 1422.222046 92.793335 1423.307495 105.667603 1409.508423 122.630371 C 1387.669067 140.640503 1351.124268 142.758789 1341.056519 113.236328 C 1331.982666 86.67749 1331.861572 41.518677 1360.332397 26.509521 C 1380.629639 15.819946 1405.749756 23.609253 1416.438965 43.907104 C 1419.44397 49.612549 1421.078735 55.938232 1421.214966 62.384277 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1378.503662 135.579102 L 1378.283936 134.089233 C 1377.797607 130.797119 1374.541382 128.670776 1371.332031 129.550415 L 1358.96936 132.9375 C 1364.910034 135.431641 1371.628052 136.23291 1378.503662 135.579102 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    fill: "#002a32",
    stroke: "none",
    d: "M 1341.165405 66.308838 C 1340.764526 66.352051 1340.367798 66.19751 1340.101318 65.895386 C 1338.215332 63.525513 1335.303955 62.207886 1332.277588 62.354614 C 1331.627563 62.435425 1331.033569 61.979126 1330.942993 61.330811 C 1330.870728 60.675415 1331.333618 60.081299 1331.986694 59.98877 C 1335.814575 59.717163 1339.531616 61.342041 1341.931396 64.33667 C 1342.362671 64.840332 1342.301636 65.598389 1341.799072 66.029175 L 1341.796021 66.03125 C 1341.61499 66.179932 1341.39624 66.275879 1341.165405 66.308838 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1377.369385 127.895752 L 1384.0354 173.061279 L 1421.75415 165.252502 L 1409.674316 119.02417 L 1377.369385 127.895752 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    fill: "#002a32",
    stroke: "none",
    d: "M 1362.221436 84.119629 L 1355.626587 89.215454 C 1355.626587 89.215454 1350.810913 71.164673 1358.046631 54.441284 L 1350.444702 42.899658 L 1351.621704 35.126709 C 1351.621704 35.126709 1339.844971 16.047852 1349.030762 10.39502 C 1358.217529 4.741577 1364.105469 16.518677 1364.105469 16.518677 C 1364.105469 16.518677 1370.465332 -2.324585 1381.536011 0.266724 C 1392.606812 2.857544 1386.952881 14.634644 1386.952881 14.634644 C 1386.952881 14.634644 1404.854492 1.679565 1413.334351 8.039551 C 1421.814209 14.39917 1411.214355 23.349609 1411.214355 23.349609 C 1411.214355 23.349609 1432.648926 23.820801 1433.355957 32.300415 C 1434.06189 40.779907 1424.640137 41.486328 1424.640137 41.486328 C 1424.640137 41.486328 1438.772827 46.432983 1438.537842 53.969971 C 1438.301758 61.507446 1427.231079 61.97876 1427.231079 61.97876 C 1427.231079 61.97876 1441.604858 71.10498 1438.540894 79.143311 C 1435.47583 87.181641 1427.467041 84.59082 1427.467041 84.59082 C 1427.467041 84.59082 1434.925537 94.119995 1432.412964 99.287476 C 1429.901367 104.45459 1423.619751 103.82666 1423.619751 103.82666 L 1411.386353 125.574951 C 1411.386353 125.574951 1401.075439 121.585449 1392.247681 129.35083 L 1370.230347 93.148682 L 1362.221436 84.119629 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1358.410889 75.93042 C 1357.318359 82.050049 1358.710938 88.351685 1362.277466 93.443359 C 1367.05957 100.161621 1374.676758 97.165405 1377.718262 89.992432 C 1380.478149 83.493774 1381.256348 72.224609 1374.334961 68.023804 C 1367.412476 63.823364 1359.830933 68.46167 1358.410889 75.93042 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1429.36731 160.349609 L 1421.915894 139.244141 C 1421.915894 139.244141 1393.01062 126.489624 1364.250854 147.672119 L 1385.402588 160.349609 L 1429.36731 160.349609 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1425.928955 150.612061 C 1404.22998 145.329224 1385.380249 149.947021 1374.671631 153.918335 L 1385.402588 160.349609 L 1429.36731 160.349609 L 1425.928955 150.612061 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1297.496704 299.305054 L 1269.686035 285.350891 C 1268.085938 284.547852 1266.217285 284.468262 1264.554077 285.132507 L 1241.774658 294.22998 C 1239.517456 295.132141 1237.985474 297.259216 1237.845093 299.686646 L 1237.4198 307.080017 C 1237.164551 311.522461 1241.49292 314.807068 1245.702271 313.36499 L 1254.157715 310.46875 C 1254.157715 310.46875 1272.05835 319.262512 1296.240479 311.725037 L 1297.496704 299.305054 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1191.779785 300.91333 L 1163.969116 286.799927 C 1162.36792 285.987915 1160.500244 285.907532 1158.837036 286.579224 L 1136.057739 295.780396 C 1133.800415 296.692444 1132.267456 298.843689 1132.128052 301.299194 L 1131.702881 308.776672 C 1131.44751 313.269592 1135.774902 316.591187 1139.985352 315.132996 L 1148.440796 312.203796 C 1148.440796 312.203796 1166.341309 321.097473 1190.523438 313.474609 L 1191.779785 300.91333 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1444.620972 168.27832 C 1430.981689 179.893677 1396.924072 213.859131 1352.674561 293.479248 L 1296.123413 293.479248 C 1296.123413 293.479248 1288.114624 300.00415 1291.412598 316.385437 C 1291.412598 316.385437 1349.433594 337.009644 1365.176636 329.942139 C 1380.918579 322.874146 1431.789307 244.889648 1454.668335 217.084167 C 1462.601929 207.442017 1476.207642 194.577881 1456.545166 169.531677 C 1453.628784 165.817444 1448.215942 165.216614 1444.620972 168.27832 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1381.469971 280.005432 L 1367.882446 267.197876 C 1362.964111 275.356201 1357.893066 284.089233 1352.674561 293.479248 L 1338.947754 293.479248 L 1347.5354 330.862488 C 1354.960327 331.735046 1361.332397 331.667542 1365.176636 329.942139 C 1369.308716 328.086304 1375.876099 321.31543 1383.709961 311.874939 L 1381.469971 280.005432 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path177",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1371.196655 712.340454 L 1384.112793 774.912476 L 1409.59082 771.143799 L 1403.465942 710.22052 L 1371.196655 712.340454 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1407.501465 750.357544 L 1403.465942 710.22052 L 1371.196655 712.340454 L 1379.27063 751.453857 L 1407.501465 750.357544 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path179",
    fill: "#007cff",
    stroke: "none",
    d: "M 1522.367554 423.800842 C 1522.367554 423.800842 1535.304932 491.637085 1491.022949 491.637085 C 1446.740967 491.637085 1387.843018 506.114624 1387.843018 506.114624 C 1387.843018 506.114624 1404.801636 522.220398 1408.570557 727.500366 L 1371.826416 729.063843 C 1371.826416 729.063843 1310.792236 497.368713 1322.833496 471.909119 C 1339.792114 436.049194 1427.605347 423.800842 1427.605347 423.800842 L 1522.367554 423.800842 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path180",
    fill: "#007cff",
    stroke: "none",
    d: "M 1367.806152 721.840332 L 1410.226685 720.584045 L 1412.402588 741.312134 L 1370.486694 743.108826 L 1367.806152 721.840332 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1367.806152 721.840332 L 1410.226685 720.584045 L 1412.402588 741.312134 L 1370.486694 743.108826 L 1367.806152 721.840332 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path182",
    fill: "#007cff",
    stroke: "none",
    d: "M 1372.64624 778.851807 C 1369.34729 779.247986 1365.864258 779.052917 1364.601807 777.766602 C 1363.936523 777.004944 1363.824707 775.907104 1364.322144 775.027161 C 1364.677124 774.244873 1365.324097 773.631714 1366.124634 773.31842 C 1370.409302 771.567993 1380.301147 775.744019 1380.73645 775.929688 C 1380.981689 776.034241 1381.13623 776.281128 1381.119019 776.547424 C 1381.098633 776.811646 1380.923706 777.037964 1380.673462 777.124207 C 1378.052979 777.932922 1375.367432 778.51123 1372.64624 778.851807 Z M 1367.806152 774.195313 C 1367.399292 774.236755 1367.000488 774.337952 1366.623169 774.495361 C 1366.110474 774.647461 1365.695435 775.025391 1365.494995 775.52179 C 1365.122681 776.360474 1365.332275 776.718323 1365.536743 776.910889 C 1366.974121 778.490906 1373.671631 777.729248 1378.537231 776.525269 C 1375.137573 775.078003 1371.497803 774.28833 1367.806152 774.195313 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    fill: "#007cff",
    stroke: "none",
    d: "M 1380.57373 777.12677 C 1380.489258 777.162109 1380.395752 777.164917 1380.309204 777.134155 C 1376.967529 776.108276 1369.899658 771.119873 1370.107178 768.067871 C 1370.085815 767.340027 1370.52124 766.400085 1372.2323 766.01886 C 1373.47937 765.733276 1374.789673 765.969543 1375.859741 766.672485 C 1379.572754 769.044922 1381.139282 776.117126 1381.215576 776.444946 C 1381.259399 776.670044 1381.177979 776.901184 1381.001953 777.047424 C 1380.873779 777.12677 1380.721191 777.155029 1380.57373 777.12677 Z M 1372.795776 767.160522 L 1372.431641 767.171631 C 1371.312622 767.402832 1371.293335 767.866943 1371.265869 768.033813 C 1371.318726 769.852417 1376.040894 773.851196 1379.562622 775.401733 C 1378.887085 772.431396 1377.31543 769.738708 1375.061279 767.689697 C 1374.395996 767.244141 1373.590332 767.056213 1372.795776 767.160522 L 1372.795776 767.160522 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1382.936768 773.083435 L 1411.9021 769.606934 C 1412.994629 769.475464 1414.031128 770.118408 1414.397339 771.154968 L 1422.462158 794.091187 C 1423.192505 796.120911 1422.139648 798.357544 1420.110229 799.087463 C 1419.849854 799.181274 1419.580322 799.246704 1419.305664 799.283813 C 1408.842163 800.355469 1399.489502 800.898438 1386.492065 802.477173 C 1371.150879 804.323242 1375.263672 805.690918 1357.259277 808.112549 C 1346.409302 809.560852 1342.938477 797.447388 1347.47229 796.286194 C 1368.242554 791.099976 1369.668823 784.470093 1376.896362 775.944458 C 1378.491455 774.283325 1380.640869 773.265015 1382.936768 773.083435 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path185",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 1399.685913 480.216309 L 1335.147339 480.216309 L 1321.304565 485.951294 C 1321.652466 499.501221 1324.699097 520.386169 1329.147583 544.367188 L 1394.202881 525.622864 C 1390.634399 508.767151 1387.843018 506.114624 1387.843018 506.114624 C 1387.843018 506.114624 1393.753296 504.662537 1403.219849 502.680786 L 1399.685913 480.216309 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 1443.496948 484.927063 C 1443.496948 484.927063 1442.278198 489.982056 1442.136841 495.743774 C 1456.785278 493.618713 1472.588257 491.940002 1487.105469 491.675903 C 1503.913574 471.479614 1489.191895 453.835876 1489.191895 453.835876 L 1463.282471 465.612854 L 1443.496948 484.927063 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path187",
    fill: "#cd7a63",
    stroke: "none",
    d: "M 1296.655518 729.103027 L 1320.679932 787.439148 L 1344.076782 782.767456 L 1327.981812 720.348816 L 1296.655518 729.103027 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1338.718872 761.989502 L 1327.981812 720.348816 L 1296.655518 729.103027 L 1312.273315 767.026978 L 1338.718872 761.989502 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path189",
    fill: "#007cff",
    stroke: "none",
    d: "M 1490.635376 427.569641 C 1490.635376 427.569641 1503.571777 495.405762 1459.289795 495.405762 C 1415.00769 495.405762 1282.161621 536.263733 1282.161621 536.263733 C 1282.161621 536.263733 1301.71228 543.456177 1335.630493 732.83252 L 1297.236328 741.547607 C 1297.236328 741.547607 1201.343018 535.055481 1213.384155 509.595825 C 1230.342773 473.735901 1395.873169 427.569641 1395.873169 427.569641 L 1490.635376 427.569641 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path190",
    fill: "#007cff",
    stroke: "none",
    d: "M 1292.525391 739.11377 L 1338.063721 729.37793 L 1342.774658 748.221313 L 1299.121338 758.27124 L 1292.525391 739.11377 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path191",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.5,
    d: "M 1292.525391 739.11377 L 1338.063721 729.37793 L 1342.774658 748.221313 L 1299.121338 758.27124 L 1292.525391 739.11377 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    fill: "#007cff",
    stroke: "none",
    d: "M 1306.219727 790.106689 C 1302.921753 790.502869 1299.438721 790.3078 1298.17627 789.021729 C 1297.510986 788.259583 1297.398071 787.161987 1297.895508 786.282043 C 1298.252563 785.5 1298.89856 784.886597 1299.699097 784.572754 C 1303.983765 782.822876 1313.874512 786.999207 1314.310913 787.18457 C 1314.557129 787.288818 1314.709717 787.535767 1314.693359 787.802856 C 1314.673096 788.066528 1314.498047 788.293396 1314.247803 788.379089 C 1311.627441 789.187805 1308.941895 789.766113 1306.219727 790.106689 Z M 1301.381592 785.449951 C 1300.973755 785.491638 1300.574951 785.593384 1300.19751 785.75 C 1299.684814 785.902588 1299.268799 786.280762 1299.069458 786.777222 C 1298.697144 787.615356 1298.906616 787.973755 1299.110107 788.16626 C 1300.548462 789.745483 1307.246094 788.984131 1312.110596 787.780457 C 1308.713013 786.332886 1305.072266 785.543213 1301.381592 785.449951 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path193",
    fill: "#007cff",
    stroke: "none",
    d: "M 1314.148193 788.381104 C 1314.063721 788.416748 1313.969116 788.420044 1313.88269 788.389282 C 1310.541992 787.363403 1303.474121 782.375 1303.681641 779.32251 C 1303.660278 778.595459 1304.095703 777.654968 1305.806641 777.273254 C 1307.053833 776.988403 1308.364014 777.22467 1309.434204 777.927612 C 1313.147217 780.299561 1314.713745 787.371765 1314.790039 787.700073 C 1314.83374 787.924927 1314.751343 788.155823 1314.576416 788.302551 C 1314.449219 788.381653 1314.295654 788.409607 1314.148193 788.381104 Z M 1306.369263 778.4151 L 1306.006104 778.42627 C 1304.887085 778.657959 1304.866699 779.12207 1304.839233 779.288696 C 1304.893188 781.108032 1309.614258 785.106323 1313.136963 786.656616 C 1312.461548 783.686279 1310.890869 780.994141 1308.63562 778.94458 C 1307.970337 778.499512 1307.163696 778.31134 1306.369263 778.4151 L 1306.369263 778.4151 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1316.51123 784.338867 L 1345.47644 780.861572 C 1346.567993 780.730103 1347.604614 781.373291 1347.971802 782.4104 L 1356.036621 805.346375 C 1356.766968 807.375793 1355.713135 809.612427 1353.684692 810.34259 C 1353.424316 810.435913 1353.154663 810.502075 1352.880005 810.538696 C 1342.416626 811.61084 1333.063965 812.15332 1320.065552 813.731567 C 1304.725342 815.577881 1308.838135 816.94635 1290.83374 819.367432 C 1279.983765 820.815735 1276.511841 808.702515 1281.046753 807.540833 C 1301.817017 802.354858 1303.242188 795.72467 1310.470825 787.200073 C 1312.065796 785.538452 1314.215332 784.519897 1316.51123 784.338867 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path195",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1333.611206 165.826599 C 1333.55835 160.277466 1338.056641 155.771729 1343.60376 155.880005 L 1428.979736 157.543335 C 1449.792725 157.96582 1468.72168 169.453735 1478.884033 187.621216 C 1498.652344 222.961609 1524.508911 295.257507 1524.093872 431.338318 L 1382.302002 431.338318 C 1382.302002 431.338318 1334.467773 254.699158 1333.611206 165.826599 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    fill: "#000000",
    stroke: "none",
    opacity: 0.4,
    d: "M 1335.692505 200.177063 C 1337.730103 220.617493 1341.103271 243.172119 1345.136719 265.950867 C 1366.574341 221.012939 1355.073242 184.222473 1355.073242 184.222473 L 1335.692505 200.177063 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path197",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1333.920532 159.672485 C 1323.937134 171.30542 1308.514648 194.539185 1261.678223 279.774536 L 1190.05249 295.020874 C 1190.05249 295.020874 1182.044678 301.620056 1185.341553 318.187927 C 1185.341553 318.187927 1262.206177 331.423767 1277.949219 324.275391 C 1293.691162 317.127014 1333.90625 256.647949 1352.366333 225.379089 C 1359.986572 212.471191 1364.058594 187.019531 1341.125732 159.761597 C 1339.24585 157.526245 1335.822754 157.456299 1333.920532 159.672485 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path198",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1583.284668 818.512939 L 1478.258423 779.838745 L 1372.089844 818.543701 C 1368.424683 819.880127 1364.545898 817.166321 1364.545898 813.264648 L 1364.545898 813.264648 C 1364.545898 811.077026 1365.81543 809.088318 1367.800049 808.16748 L 1478.258423 756.915771 L 1587.605957 808.162842 C 1589.577393 809.087036 1590.836792 811.067871 1590.836792 813.245361 L 1590.836792 813.245361 C 1590.836792 817.150269 1586.948853 819.862061 1583.284668 818.512939 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path199",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 1583.284668 818.512939 L 1478.258423 779.838745 L 1372.089844 818.543701 C 1368.424683 819.880127 1364.545898 817.166321 1364.545898 813.264648 L 1364.545898 813.264648 C 1364.545898 811.077026 1365.81543 809.088318 1367.800049 808.16748 L 1478.258423 756.915771 L 1587.605957 808.162842 C 1589.577393 809.087036 1590.836792 811.067871 1590.836792 813.245361 L 1590.836792 813.245361 C 1590.836792 817.150269 1586.948853 819.862061 1583.284668 818.512939 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1453.509766 788.861267 L 1478.258423 779.838745 L 1501.874023 788.534485 L 1501.874023 767.983398 L 1478.258423 756.915771 L 1453.509766 768.399536 L 1453.509766 788.861267 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path201",
    fill: "#1a2e35",
    stroke: "none",
    d: "M 1477.691895 819.409668 L 1477.691895 819.409668 C 1472.883301 819.409668 1468.864136 815.754639 1468.408447 810.968201 L 1465.443115 779.835938 L 1465.443115 521.431641 L 1489.939575 521.431641 L 1489.939575 779.835938 L 1486.975342 810.968201 C 1486.519531 815.754639 1482.49939 819.409668 1477.691895 819.409668 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.3,
    d: "M 1477.691895 819.409668 L 1477.691895 819.409668 C 1472.883301 819.409668 1468.864136 815.754639 1468.408447 810.968201 L 1465.443115 779.835938 L 1465.443115 521.431641 L 1489.939575 521.431641 L 1489.939575 779.835938 L 1486.975342 810.968201 C 1486.519531 815.754639 1482.49939 819.409668 1477.691895 819.409668 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path203",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1465.443115 551.52301 L 1489.939575 551.52301 L 1489.939575 521.431641 L 1465.443115 521.431641 L 1465.443115 551.52301 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    fill: "#007cff",
    stroke: "none",
    d: "M 1648.07251 497.911621 C 1620.357422 490.84375 1591.880493 486.95752 1563.324219 486.241211 C 1533.89502 485.503296 1423.736816 486.130493 1397.577148 486.120056 C 1365.733032 486.107422 1333.890015 490.032898 1302.994995 497.911621 C 1283.574585 502.864502 1289.560181 530.891357 1307.101685 531.215881 C 1308.651978 531.244629 1641.653687 531.143616 1642.876343 531.199097 C 1661.226563 532.033203 1667.919067 502.973389 1648.07251 497.911621 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path205",
    fill: "#000000",
    stroke: "none",
    opacity: 0.3,
    d: "M 1648.07251 497.911621 C 1620.357422 490.84375 1591.880493 486.95752 1563.324219 486.241211 C 1533.89502 485.503296 1423.736816 486.130493 1397.577148 486.120056 C 1365.733032 486.107422 1333.890015 490.032898 1302.994995 497.911621 C 1283.574585 502.864502 1289.560181 530.891357 1307.101685 531.215881 C 1308.651978 531.244629 1641.653687 531.143616 1642.876343 531.199097 C 1661.226563 532.033203 1667.919067 502.973389 1648.07251 497.911621 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path206",
    fill: "#007cff",
    stroke: "none",
    d: "M 1312.011963 530.617981 C 1367.950684 516.352539 1427.202515 516.352905 1483.140259 530.617981 C 1504.301147 536.014526 1513.328247 503.310486 1492.157227 497.911621 C 1430.371338 482.154541 1364.78186 482.154541 1302.994995 497.911621 C 1281.858521 503.302063 1290.816406 536.023376 1312.011963 530.617981 L 1312.011963 530.617981 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "path207",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1312.011963 530.617981 C 1367.950684 516.352539 1427.202515 516.352905 1483.140259 530.617981 C 1504.301147 536.014526 1513.328247 503.310486 1492.157227 497.911621 C 1430.371338 482.154541 1364.78186 482.154541 1302.994995 497.911621 C 1281.858521 503.302063 1290.816406 536.023376 1312.011963 530.617981 L 1312.011963 530.617981 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    fill: "#007cff",
    stroke: "none",
    d: "M 1559.01001 255.208801 C 1555.507568 255.140869 1551.987915 256.70874 1549.645142 260.605835 C 1504.780273 335.215088 1488.839966 424.900391 1504.319458 510.470032 C 1505.289917 515.831665 1508.961182 518.330811 1513.035278 518.608765 C 1519.825439 519.072021 1640.725952 518.643738 1645.111328 518.63501 C 1651.705078 518.621643 1658.947998 513.017944 1657.400757 504.458801 C 1643.015747 424.941711 1658.855347 341.182129 1700.445801 272.018372 C 1705.61438 263.42334 1697.992188 255.357544 1690.286499 255.208801 C 1686.783081 255.140869 1566.715698 255.357544 1559.01001 255.208801 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path209",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1559.01001 255.208801 C 1555.507568 255.140869 1551.987915 256.70874 1549.645142 260.605835 C 1504.780273 335.215088 1488.839966 424.900391 1504.319458 510.470032 C 1505.289917 515.831665 1508.961182 518.330811 1513.035278 518.608765 C 1519.825439 519.072021 1640.725952 518.643738 1645.111328 518.63501 C 1651.705078 518.621643 1658.947998 513.017944 1657.400757 504.458801 C 1643.015747 424.941711 1658.855347 341.182129 1700.445801 272.018372 C 1705.61438 263.42334 1697.992188 255.357544 1690.286499 255.208801 C 1686.783081 255.140869 1566.715698 255.357544 1559.01001 255.208801 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path210",
    fill: "#007cff",
    stroke: "none",
    d: "M 1526.124268 504.458801 C 1511.739258 424.942078 1527.579956 341.182129 1569.169312 272.018372 C 1576.687866 259.516235 1557.143311 248.135071 1549.645142 260.605835 C 1504.780273 335.215088 1488.839966 424.900391 1504.320435 510.470032 C 1506.906372 524.767517 1528.703003 518.710022 1526.124268 504.458801 L 1526.124268 504.458801 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "path211",
    fill: "#ffffff",
    stroke: "none",
    d: "M 1526.124268 504.458801 C 1511.739258 424.942078 1527.579956 341.182129 1569.169312 272.018372 C 1576.687866 259.516235 1557.143311 248.135071 1549.645142 260.605835 C 1504.780273 335.215088 1488.839966 424.900391 1504.320435 510.470032 C 1506.906372 524.767517 1528.703003 518.710022 1526.124268 504.458801 L 1526.124268 504.458801 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeAgent);
export default __webpack_public_path__ + "static/media/welcome-agent.b386335e3dd78e0ad7f6774765c92cd3.svg";
export { ForwardRef as ReactComponent };